import * as React from "react";
import "./video.css";

import sample1 from "../../assets/Video1.mp4";
import thumb1 from "../../assets/Picture4.jpg";

import {
  ImageList,
  ImageListItem,
  Dialog,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { PlayCircleOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet-async";
export default function VideoList() {
  <Helmet>
    <title>Videos – Ponvel Exim | Product & Brand Media Gallery</title>
    <meta
      name="description"
      content="Watch Ponvel Exim’s video gallery featuring product demos, brand stories, and manufacturing processes for food, FMCG, coir, and textile lines."
    />
    <meta
      name="keywords"
      content="Ponvel Exim video gallery, product videos, brand videos"
    />
    <link rel="canonical" href="https://ponvelexim.com/video" />

    {/* Open Graph */}
    <meta property="og:site_name" content="Ponvel Exim" />
    <meta property="og:locale" content="en_IN" />
    <meta
      property="og:title"
      content="Videos – Ponvel Exim | Product & Brand Media Gallery"
    />
    <meta
      property="og:description"
      content="Explore Ponvel Exim’s video media gallery showcasing product demos, brand stories, and processes."
    />
    <meta property="og:image" content="https://ponvelexim.com/logo192.png" />
    <meta property="og:url" content="https://ponvelexim.com/video" />
    <meta property="og:type" content="website" />

    {/* Twitter Meta */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Videos – Ponvel Exim | Media Gallery" />
    <meta
      name="twitter:description"
      content="View our video gallery of product demonstrations, behind-the-scenes, and brand showcases."
    />
    <meta name="twitter:image" content="https://ponvelexim.com/logo192.png" />
  </Helmet>;

  const itemData = [{ src: sample1, title: "Video 1", poster: thumb1 }];

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));

  let cols = 4;
  if (isXs) cols = 1;
  else if (isSm) cols = 2;
  else if (isMdUp) cols = 4;

  const [open, setOpen] = React.useState(false);
  const [activeIndex, setActiveIndex] = React.useState(null);
  const vidRef = React.useRef(null);

  const handleOpen = (idx) => {
    setActiveIndex(idx);
    setOpen(true);
  };

  const handleClose = () => {
    if (vidRef.current) vidRef.current.pause();
    setOpen(false);
  };

  const goNext = () => {
    if (vidRef.current) vidRef.current.pause();
    setActiveIndex((i) => (i === null ? 0 : (i + 1) % itemData.length));
  };

  const goPrev = () => {
    if (vidRef.current) vidRef.current.pause();
    setActiveIndex((i) =>
      i === null ? 0 : (i - 1 + itemData.length) % itemData.length
    );
  };

  React.useEffect(() => {
    function onKey(e) {
      if (!open) return;
      if (e.key === "ArrowRight") goNext();
      if (e.key === "ArrowLeft") goPrev();
      if (e.key === "Escape") handleClose();
      if (e.key === " ") {
        e.preventDefault();
        if (vidRef.current) {
          vidRef.current.paused
            ? vidRef.current.play()
            : vidRef.current.pause();
        }
      }
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      <ImageList cols={cols} gap={10} className="picture-section">
        {itemData.map((item, idx) => (
          <ImageListItem key={idx}>
            <button
              onClick={() => handleOpen(idx)}
              className="picture-trigger"
              aria-label={`Open ${item.title}`}>
              <img
                src={item.poster}
                alt={item.title}
                loading="lazy"
                className="picture-thumb"
              />
              <span className="video-play-badge" aria-hidden>
                <PlayCircleOutlined />
              </span>
            </button>
          </ImageListItem>
        ))}
      </ImageList>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="lg"
        PaperProps={{ className: "lightbox-paper" }}>
        {activeIndex !== null && (
          <Box className="lightbox-root">
            <IconButton
              aria-label="Close"
              onClick={handleClose}
              className="icon-btn lightbox-close">
              <CloseIcon />
            </IconButton>

            <IconButton
              aria-label="Previous"
              onClick={goPrev}
              className="icon-btn lightbox-prev">
              <ArrowBackIosNewIcon />
            </IconButton>
            <IconButton
              aria-label="Next"
              onClick={goNext}
              className="icon-btn lightbox-next">
              <ArrowForwardIosIcon />
            </IconButton>

            <Box className="lightbox-stage">
              <video
                ref={vidRef}
                className="lightbox-video"
                src={itemData[activeIndex].src}
                poster={itemData[activeIndex].poster}
                controls
                playsInline
                autoPlay
                controlsList="nodownload noplaybackrate"
              />
            </Box>

            <Box className="lightbox-caption">
              <div className="lightbox-title">
                {itemData[activeIndex].title}
              </div>
            </Box>
          </Box>
        )}
      </Dialog>
    </>
  );
}
